@if (isDialogMode) {
<mat-toolbar class="header">
  <div class="back" mat-dialog-close matTooltip="Atrás" matTooltipPosition="right">
    <mat-icon >arrow_back_ios_new</mat-icon>
  </div>
  <span class="header-title">Crear {{'budget' | human}}</span>
</mat-toolbar>
}

@if (chatMode()) {
  <mat-toolbar class="header">
    <span class="header-title">Crear {{'budget' | human}}</span>
    <span class="expander"></span>
    <button mat-icon-button (click)="cancel.emit()" class="cancel-button">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
}

<div class="dialog-wrapper" #wrapper>
  <div class="items-wrapper">
    <div class="items" #inputs>
      @if (isExpandedMode) {
        <div class="expanded-views-container">
          @for (formGroup of inventoryActionFormArray.controls; track formGroup) {
            <div class="expanded-view">
              <div class="expanded-view-header">
                <div class="tag-circle" [style.background-color]="getTag(formGroup.get('tag_id')?.value)?.color"></div>
                <span class="header-text"> {{getTag(formGroup.get('tag_id')?.value)?.name}}</span>
                <div class="expander"></div>
                <button mat-icon-button matSuffix (click)="removeItem($index)" matTooltip="Remover">
                  <mat-icon color="warn">delete</mat-icon>
                </button>
              </div>
              <span class="photo-subtitle">Fotos adjuntas</span>
              <app-image-uploader
                [gallery]="picturesInGallery"
                (uploaded)="setImagesToInventoryAction(formGroup, $event)"
                [scrollTarget]="wrapper"
                [small]="true"
                [allowUploadPhoto]="false"
                [allowUploadFile]="false"
                [allowAdvanceUpload]="false"
                >
              </app-image-uploader>
              <app-inventory-action-form
                [parentFormGroup]="(formGroup | formGroup)"
                [filterCategories]="getTagCategories(formGroup.getRawValue().tag_id)"
                [showTotals]="false"
                [simpleView]="false"
                [brandId]="sourceDocument().object?.brand?.id"
                [requirementId]="sourceDocument().requirement_id"
                [checkForDiscounts]="true"
                [enableDiscounts]="true"
                parentModel="budget"
                (dataChanged)="calculateValues()"
              >
              </app-inventory-action-form>
            </div>
          }
        </div>

      }
      @else {
        @for (formGroup of inventoryActionFormArray.controls; track formGroup) {
          <div class="simple-view-container">
            <div class="tag-container">
              <div class="tag-bar" [style.background-color]="getTag(formGroup.get('tag_id')?.value)?.color"></div>
            </div>
            <div class="inventory-container">
              <app-inventory-action-form
                  [parentFormGroup]="(formGroup | formGroup)"
                  [filterCategories]="getTagCategories(formGroup.getRawValue().tag_id)"
                  (dataChanged)="calculateValues()"
                  [showTotals]="false"
                  [brandId]="sourceDocument().object?.brand?.id"
                  parentModel="budget"
                  [gallery]="picturesInGallery"
                  [simpleView]="true"
                >
                </app-inventory-action-form>
            </div>
            <button mat-mini-fab class="delete-button" (click)="removeItem($index)" matTooltip="Remover" matTooltipPosition="left"><mat-icon>delete</mat-icon></button>

            <button mat-mini-fab class="duplicate-button" (click)="duplicateInventoryAction($index)"  matTooltip="Duplicar" matTooltipPosition="left" [disabled]="saving()">
              @if (!saving()){
                <mat-icon>content_copy</mat-icon>
              }
              @else {
                <mat-icon>hourglass_empty</mat-icon>
              }
            </button>
          </div>
        }
      }
      <div class="add-item" >
        @for (tag of tags(); track tag.id) {
          <button class="add-button" [class.saving]="saving()"
              mat-button
              (click)="addInventoryAction(tag)"
              [disabled]="saving()"
              [style.background-color]="tag?.color"
              [style.color]="'white'"
          >
            <i class="fas fa-plus"></i>&nbsp;{{tag.name}}
          </button>
        }
      </div>
    </div>

  </div>

  @if (inventoryActionFormArray.controls.length > 0) {
    <div class="totals-wrapper">
      <div class="subtitle">Totales</div>
      <div class="totals">
        @for(category of categories(); track category.id) {
          @if ( totals[category.id] !== undefined ){
            <div class="total">{{category.name}}: {{ totals[category.id] | money }}</div>
          }
        }
        <div class="total" [ngClass]="{'discount': discountTotal > 0}">Neto: {{total() + discountTotal| money}}</div>
        @if (discountTotal > 0) {
          <div class="total">Descuentos: -{{ discountTotal | money }}</div>
          <div class="total discount__label">Neto: {{ total() | money }}</div>
        }
    
        <div class="total">{{'tax' | human | uppercase}}: {{ total() * (tax - 1) | money}}</div>
        <div class="total">Total: {{total() * tax | money}}</div>
      </div>  
    </div>
  }
</div>

<mat-toolbar class="footer">
  @if (isDialogMode) {
    <button mat-raised-button mat-dialog-close class="hide-mobile"> 
      Cancelar
    </button>
    <button mat-icon-button mat-dialog-close class="hide-desktop"> 
      <mat-icon>close</mat-icon>
    </button>
  }
  <div>
    <span class="total">Total: <b>{{total() * tax | money}}</b></span>
  </div>
  @if (isDialogMode) {
    <button mat-raised-button
            type="button"
            class="button-primary"
            [disabled]="saving()"
            class="hide-mobile"
            (click)="saveForm()">
      @if (saving()) {
        <mat-spinner diameter="30"></mat-spinner>
      } @else {
        Guardar
      }
    </button>
    <button mat-icon-button
            type="button"
            [disabled]="saving()"
            class="hide-desktop"
            (click)="saveForm()">
      @if (saving()) {
        <mat-spinner diameter="30"></mat-spinner>
      } @else {
        <mat-icon class="icon-primary">save</mat-icon>
      }
    </button>
  }
</mat-toolbar>

